// extracted by mini-css-extract-plugin
module.exports = {"root":"RegisterPage_root__dV0r2"};